import {ChatMessage, Citation, SendMessageResponse} from "features/chat/services/ChatService/types";
import {ChatService} from "features/chat/services/ChatService/service";
import {getSiteSpecificConfig} from "features/services/utils/env-helper";
import {getFormattedMessage} from "features/services/utils/language-helper";

export class ChatServiceQueryMethods {
    public static readonly sendMessage = async (message: string, sessionId?: string): Promise<ChatMessage | null> => {
        try {
            const response = await ChatService.SendMessage({
                question: message.trim(),
                siteName:  getSiteSpecificConfig().siteNameId,
                sessionId,
            });

            const parsedAnswer = ChatServiceQueryMethods.parseCitations(response);

            return {
                id: (Date.now() + 1).toString(),
                text: parsedAnswer || getFormattedMessage("jm.components.organisms.chatWidget.errorMessage"),
                sender: 'bot',
                timestamp: new Date()
            };
        } catch (e) {
            console.error("Failed to fetch user:", e);
            throw e;

        }

    }

    private static readonly rewriteUrl = (url: string) => {
        try {
            const parsedUrl = new URL(url, window.location.href);
            if (parsedUrl.origin === window.location.origin || parsedUrl.origin === 'https://devbostad.jm.se') {
                return parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
            }
            return url;
        } catch {
            return url;
        }
    }

    private static readonly parseCitations = (data: SendMessageResponse | null) => {
        if (!data || !data.answer) return null;
        if (!data.citations || data.citations.length < 1) return data.answer;

        let parsedAnswer = data.answer;

        data.citations.forEach((citation: Citation) => {
            const citationId = `[${citation.citationId}]`;
            const citationText = `[${citation.urlTitle}](${ChatServiceQueryMethods.rewriteUrl(citation.url)})`;
            parsedAnswer = parsedAnswer.replaceAll(citationId, citationText);
        });

        console.log('Parsed answer:', parsedAnswer);

        return parsedAnswer;
    }
}
